import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
export const namespace = "network";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    get: (id, roleId) => [
      `${prefix}/profile/${namespace}/${id}${roleId ? `?role_id=${roleId}` : ""}`,
    ],
    getFromId: ({ id, extend = [] }) => {
      let url = `${prefix}/profile/networks/${id}`;
      if (extend.length) url += `?extend=${extend.join(",")}`;
      return [url];
    },
    validateCode: (code) => [`${prefix}/profile/${namespace}/validate/${code}`],
    getAll: () => [`${prefix}/profile/profile/${namespace}`],
    getAvailableNetworks: () => [`${prefix}/profile/networks`],
    getMembers: (id) => [`${prefix}/profile/${namespace}/${id}/members?extend=profile`],
    getUserInfoFromNetwork: (data) => {
      return [
        `${prefix}/profile/${namespace}/${data.networkId}/members/${data.organizationId}/${data.userId}`
      ]
    }
  },
  post: {
    create: (data, endpoint) => [endpoint, data],
  },
  put: {
    updateNetwork: (id, data) => [`${prefix}/profile/${namespace}/${id}`, data],
  },
});

export default nameSpace;
